import React from 'react';
import { Card, Space, Button, Avatar, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { theme } from '../utils/theme';

const { Title, Text } = Typography;

const AppointmentList = ({ appointments }) => (
  <>
    <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
      <Title level={4} style={{ margin: 0 }}>Upcoming Appointments</Title>
      <Button type="primary" icon={<PlusOutlined />}>Schedule Appointment</Button>
    </Space>
    {appointments.map(appt => (
      <Card 
        key={appt.id}
        style={{ marginBottom: '16px', borderRadius: '8px' }}
        bodyStyle={{ padding: '16px' }}
      >
        <Space style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space size="middle">
            <Avatar 
              style={{ backgroundColor: theme.primaryBlue, color: theme.white }}
              size="large"
            >
              {appt.patient.charAt(0)}
            </Avatar>
            <div>
              <Text strong>{appt.patient}</Text>
              <div><Text type="secondary">{appt.type}</Text></div>
            </div>
          </Space>
          <Space size="large">
            <div>
              <Text type="secondary">Time</Text>
              <div><Text strong>{appt.time}</Text></div>
            </div>
            <div>
              <Text type="secondary">Duration</Text>
              <div><Text strong>{appt.duration}</Text></div>
            </div>
          </Space>
          <Space>
            <Button>Reschedule</Button>
            <Button type="primary">Start Session</Button>
          </Space>
        </Space>
      </Card>
    ))}
  </>
);

export default AppointmentList;